import { Stack, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

import { useAuth } from "@/providers";
import { useRecentComments } from "@/shared/domain/comments/hooks";

import { Comments } from "../shared/components/comments";

interface RecentCommentsProps {
  count: number;
}

export function RecentComments({ count }: RecentCommentsProps) {
  const theme = useTheme();
  const { orgRoles, currentUser } = useAuth();

  const [avatarMap, setAvatarMap] = useState<{ [key: string]: string }>({});

  const { data: comments = [], isLoading } = useRecentComments({});

  // Build avatar map from org roles
  useEffect(() => {
    if (orgRoles === null) {
      return;
    }

    const newAvatarMap: { [key: string]: string } = {};
    orgRoles.forEach((role) => {
      newAvatarMap[role.user.user_id] = role.user.picture_url ?? "";
    });

    setAvatarMap(newAvatarMap);
  }, [orgRoles]);

  // Show only the first 'count' comments
  const displayedComments = comments.slice(0, count);

  if (isLoading) {
    return null; // Or a skeleton loader
  }

  return (
    <Stack
      sx={{
        mt: theme.spacing(1.5),
        mb: theme.spacing(3),
      }}
    >
      <Comments.List>
        {displayedComments.map((comment) => {
          const avatarUrl = avatarMap[comment.created_by] ?? "";
          return (
            <Comments.Item
              key={comment.comment_id}
              comment={comment}
              avatarUrl={avatarUrl}
              currentUserId={currentUser?.user_id ?? ""}
              summaryView={true}
            />
          );
        })}
      </Comments.List>
    </Stack>
  );
}
